const handelPhonenumber = (phonenumber = "") => {
    if (phonenumber.startsWith(0)) {
        phonenumber = "+249" + phonenumber.substring(1, phonenumber.length)
    }
    return phonenumber
}

export default handelPhonenumber